module.exports = __webpack_public_path__ + "static/media/Logo.c2b617c6.png";